import {
    primaryColor,
    successColor,
    warningColor,
    dangerColor,
    infoColor,
    roseColor,
    grayColor,
} from "assets/jss/material-dashboard-react.jsx";

const statisticsStyle = {
    cardCategory: {
        color: "#999999",
        margin: "0",
        fontSize: "14px",
        marginTop: "0",
        paddingTop: "10px",
        marginBottom: "0"
    },
    cardCategoryWhite: {
        color: "rgba(255,255,255,.62)",
        margin: "0",
        fontSize: "14px",
        marginTop: "0",
        marginBottom: "0"
    },
    cardTitle: {
        color: "#3C4858",
        marginTop: "0px",
        minHeight: "auto",
        fontWeight: "300",
        fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
        marginBottom: "3px",
        textDecoration: "none",
        "& small": {
            color: "#777",
            fontSize: "65%",
            fontWeight: "400",
            lineHeight: "1"
        }
    },
    cardTitleWhite: {
        color: "#FFFFFF",
        marginTop: "0px",
        minHeight: "auto",
        fontWeight: "300",
        fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
        marginBottom: "3px",
        textDecoration: "none",
        "& small": {
            color: "#777",
            fontSize: "65%",
            fontWeight: "400",
            lineHeight: "1"
        }
    },
    chartContainer: {
        "& .ct-grid": {
            stroke: "rgba(0, 0, 0, 0.2)"
        },
        "& .ct-label": {
            color: "rgba(0, 0, 0, 0.2)"
        },
        "& .ct-series-a .ct-point, .ct-series-a .ct-line, .ct-series-a .ct-bar, .ct-series-a .ct-slice-donut": {
            stroke: successColor,
        },
        "& .ct-series-b .ct-point, .ct-series-b .ct-line, .ct-series-b .ct-bar, .ct-series-b .ct-slice-donut": {
            stroke: warningColor,
        },
        "& .ct-series-c .ct-point, .ct-series-c .ct-line, .ct-series-c .ct-bar, .ct-series-c .ct-slice-donut": {
            stroke: dangerColor,
        },
        "& .ct-series-d .ct-point, .ct-series-d .ct-line, .ct-series-d .ct-bar, .ct-series-d .ct-slice-donut": {
            stroke: primaryColor,
        },
        "& .ct-series-e .ct-point, .ct-series-e .ct-line, .ct-series-e .ct-bar, .ct-series-e .ct-slice-donut": {
            stroke: infoColor,
        },
        "& .ct-series-f .ct-point, .ct-series-f .ct-line, .ct-series-f .ct-bar, .ct-series-f .ct-slice-donut": {
            stroke: roseColor,
        },
        "& .ct-series-g .ct-point, .ct-series-g .ct-line, .ct-series-g .ct-bar, .ct-series-g .ct-slice-donut": {
            stroke: grayColor,
        },
        "& .ct-legend": {
            position: "relative",
            zIndex: 10,
            listStyle: "none",
            textAlign: "center",
        },
        "& .ct-legend li": {
            position: "relative",
            paddingLeft: "23px",
            paddingRight: "10px",
            marginBottom: "3px",
            display: "inline-block",
            "&:before": {
                width: "10px",
                height: "10px",
                position: "absolute",
                left: 0,
                top: 3,
                content: "''",
                border: "3px solid transparent",
                borderRadius: "10px",
            },
        },
        "& .ct-legend li.inactive:before": {
            background: "transparent",
        },
        "& .ct-legend .ct-legend-inside": {
            position: "absolute",
            top: 0,
            right: 0,
        },
        "& .ct-legend .ct-series-0:before": {
            backgroundColor: successColor,
            borderColor: successColor,
        },
        "& .ct-legend .ct-series-1:before": {
            backgroundColor: warningColor,
            borderColor: warningColor,
        },
        "& .ct-legend .ct-series-2:before": {
            backgroundColor: dangerColor,
            borderColor: dangerColor,
        },
        "& .ct-bar": {
            strokeWidth: 20
        }
    },
    mobileWideChart: {
        overflowX: "auto",
        "& svg": {
            minWidth: "700px",
        },
    },
    successChart: {
        "& .ct-point, .ct-line, .ct-bar, .ct-slice-donut": {
            stroke: successColor,
        }
    },
    warningChart: {
        "& .ct-point, .ct-line, .ct-bar, .ct-slice-donut": {
            stroke: warningColor,
        }
    },
    dangerChart: {
        "& .ct-point, .ct-line, .ct-bar, .ct-slice-donut": {
            stroke: dangerColor,
        }
    },
    primaryChart: {
        "& .ct-point, .ct-line, .ct-bar, .ct-slice-donut": {
            stroke: primaryColor,
        }
    },
    infoChart: {
        "& .ct-point, .ct-line, .ct-bar, .ct-slice-donut": {
            stroke: infoColor,
        }
    },
    roseChart: {
        "& .ct-point, .ct-line, .ct-bar, .ct-slice-donut": {
            stroke: roseColor,
        }
    },
    grayChart: {
        "& .ct-point, .ct-line, .ct-bar, .ct-slice-donut": {
            stroke: grayColor,
        }
    },
    select: {
        width: "100%",
    },
    selectWrapper: {
        margin: "0 1em",
        height: "58px",
        width: "100%",
        maxWidth: "192px",
    },
    dateTime: {
        margin:"0 1em"
    },
    shareSalesChart: {
        "& .ct-label.ct-vertical": {
            color: "rgba(0, 0, 0, 0.8)"
        }
    }
};

export default statisticsStyle;


// WEBPACK FOOTER //
// ./src/assets/jss/material-dashboard-react/views/statisticsStyle.jsx